import React from 'react';
import useFeatureWireStore from './state-hooks';
import Option from './option';

export default function Author() {
  const author = useFeatureWireStore(state => state.featureable.author);

  if (!author) {
    return null;
  }

  return (
    <Option featureable={author} border />
  );
}
